import {Injectable} from "@angular/core";
import {Lot} from "../../models/Lot";
import {TypeCPVClass} from "../../models/TypeCPVClass";
import {TypeLotsFNSSimple} from "../../models/TypeLotsFNSSimple";
import {TypeMontant} from "../../models/TypeMontant";
import {TypeObjCPV} from "../../models/TypeObjCPV";

@Injectable({
  providedIn: 'root'
})

export class lotsService {

  setValueFromControlName(value: any, attribut: any[]) {
    if (value && value != '') {
      attribut[attribut.length++] = value;
    }
  }

  constructor() {
  }

  getlots(controls, formExtractorService): TypeLotsFNSSimple {

    const lot_iters = formExtractorService.getIndexes(Array.from(controls.keys()), [''], '_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_');
    const marche_alloti = controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_SepSep_TypeOuiNon_SepAtt_oui') === 'Oui';
    let lot_iter = 0;
    const lots = new TypeLotsFNSSimple();

    if (!marche_alloti) {
      return null;
    }

    lot_iter = 0;
    lot_iters.forEach(() => {
      lots.lot[lot_iter] = new Lot();
      lots.lot[lot_iter].description = controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_' + (Number(lot_iter + 1)) + '_SepSep_Lot_SepAtt_description')
      lots.lot[lot_iter].lieuExecutionLivraison = controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_' + (Number(lot_iter + 1)) + '_SepSep_Lot_SepAtt_lieuExecutionLivraison')
      lots.lot[lot_iter].numLot = controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_' + (Number(lot_iter + 1)) + '_SepSep_Lot_SepAtt_numLot')

      lots.lot[lot_iter].codeCPV = new TypeObjCPV();

      lots.lot[lot_iter].estimationValeur = new TypeMontant();
      lots.lot[lot_iter].estimationValeur.devise = controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_' + (Number(lot_iter + 1)) + '_SepSep_Lot_SepSep_TypeMontant_SepAtt_devise')
      lots.lot[lot_iter].estimationValeur.valeur = controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_' + (Number(lot_iter + 1)) + '_SepSep_Lot_SepSep_TypeMontant_SepAtt_valeur')

      lots.lot[lot_iter].codeCPV.objetPrincipal = new TypeCPVClass();
      lots.lot[lot_iter].codeCPV.objetPrincipal.classPrincipale = controls.get('_SepSep_Initial_SepSep_TypeLotsFNSSimple_index_' + (Number(lot_iter + 1)) + '_SepSep_Lot_SepSep_TypeObjCPV_SepSep_TypeCPVClass_SepAtt_classPrincipale')
      lot_iter++;
    });

    return lots;
  }
}
